<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Asterisk" class="d-icon d-icon--asterisk" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 3a.5.5 0 1 0-1 0v2.134L3.652 4.067a.5.5 0 0 0-.5.866L5 6 3.152 7.067a.5.5 0 1 0 .5.866L5.5 6.866V9a.5.5 0 0 0 1 0V6.866l1.848 1.067a.5.5 0 0 0 .5-.866L7 6l1.848-1.067a.5.5 0 0 0-.5-.866L6.5 5.134V3Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconAsterisk',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
